module.exports = __webpack_public_path__ + "static/media/palm_earring_banner_mobile2.fddb4d21.jpg";